// RequireSysadmin — route guard for the platform (sysadmin) trust zone (ADR-018).
// The PLATFORM_NAV tabs are already is_sysadmin-gated in the nav, but that only
// hides the link; this stops a non-sysadmin who types /platform/sso directly. The
// REAL gate is the backend (`requireSysadmin` on every /api/platform/* route) — a
// non-sysadmin gets nothing from the API regardless; this is the UX (don't render a
// dead page). Renders the child routes via <Outlet/> for a sysadmin, else bounces
// home. Mirrors the "guard lands with the portal slice" note in router/index.tsx.

import { Navigate, Outlet } from 'react-router-dom';
import { useMe } from '../../hooks/useMe.js';
import { PageLoader } from '../ui/PageLoader.js';

export function RequireSysadmin() {
  const { data: me, isPending } = useMe();
  if (isPending) return <PageLoader />;
  if (!me?.user.is_sysadmin) return <Navigate to="/" replace />;
  return <Outlet />;
}
